export default __webpack_public_path__ + "static/media/img_02.bbda6650.jpg";